import React, { useCallback, useState } from "react";

import Modal from "../common/Modal";
import { storeFreightFormRequestRemarks } from "../../utils/api";
import { showError, showSuccess } from "../../utils/toast";

const iconBtn =
  "inline-flex items-center justify-center w-8 h-8 rounded-md text-gray-500 hover:text-[#064E8D] hover:bg-gray-100 transition-colors";

const FreightFormRequestDtActions = ({ row, onUpdated }) => {
  const id = row?.id;
  const type = row?.type != null ? String(row.type).toLowerCase() : "";
  const [remarksOpen, setRemarksOpen] = useState(false);
  const [draftRemarks, setDraftRemarks] = useState("");
  const [saving, setSaving] = useState(false);

  const openRemarks = useCallback(() => {
    setDraftRemarks(row?.remarks != null ? String(row.remarks) : "");
    setRemarksOpen(true);
  }, [row]);

  const saveRemarks = useCallback(async () => {
    if (id == null || (type !== "buyer" && type !== "seller")) return;
    setSaving(true);
    try {
      await storeFreightFormRequestRemarks({ type, id, remarks: draftRemarks });
      showSuccess("Remarks saved");
      setRemarksOpen(false);
      onUpdated?.();
    } catch (e) {
      showError(e.message || "Save failed");
    } finally {
      setSaving(false);
    }
  }, [draftRemarks, id, onUpdated, type]);

  if (id == null || (type !== "buyer" && type !== "seller")) {
    return <span className="text-gray-400 text-xs">—</span>;
  }

  return (
    <>
      <div className="flex flex-row flex-wrap items-center justify-center gap-1">
        <button type="button" className={iconBtn} title="Edit remarks" onClick={openRemarks}>
          <i className="fas fa-comment-alt text-sm" aria-hidden />
        </button>
      </div>

      <Modal open={remarksOpen} title="Remarks" onClose={() => !saving && setRemarksOpen(false)}>
        <div className="flex flex-col gap-3">
          <p className="text-xs text-gray-600 m-0">
            {type === "buyer" ? "Buyer" : "Seller"} form #{id}. Update internal remarks here; use the{" "}
            <strong>Status</strong> column for pending / complete / rejected.
          </p>
          <textarea
            className="w-full min-h-[120px] border border-gray-300 rounded-md p-2 text-sm"
            value={draftRemarks}
            onChange={(e) => setDraftRemarks(e.target.value)}
            disabled={saving}
            placeholder="Internal notes…"
          />
          <div className="flex justify-end gap-2">
            <button type="button" className="btn-outline" disabled={saving} onClick={() => setRemarksOpen(false)}>
              Cancel
            </button>
            <button type="button" className="btn-primary" disabled={saving} onClick={saveRemarks}>
              {saving ? "Saving…" : "Save"}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FreightFormRequestDtActions;
